type LogoMarkProps = {
  size?: 'sm' | 'md' | 'lg';
  sparkle?: boolean;
};

const sizes = {
  sm: 'size-7 rounded-lg',
  md: 'size-10 rounded-xl',
  lg: 'size-12 rounded-[14px]',
};

export function LogoMark({ size = 'sm', sparkle = false }: LogoMarkProps) {
  return (
    <span
      aria-hidden="true"
      className={`grid shrink-0 place-items-center bg-accent text-white shadow-[0_8px_30px_rgba(114,95,231,0.18)] ${sizes[size]}`}
    >
      {sparkle ? (
        <svg viewBox="0 0 24 24" className="size-5" fill="none">
          <path d="M12 2l1.6 5.1L19 9l-5.4 1.9L12 16l-1.6-5.1L5 9l5.4-1.9L12 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="m18.5 15 .8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z" fill="currentColor" />
        </svg>
      ) : (
        <span className="size-[38%] rotate-45 rounded-[1px] bg-white" />
      )}
    </span>
  );
}
